<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId">
        <template v-slot:actions>
          <a-space>
            <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
          </a-space>
        </template>
      </project-page-header>
      <div class="page-title">财务进展数据</div>
      <div class="panel-body">
        <div class="w800">
          <a-steps progress-dot class="v-my-md" size="small" :current="currentStep">
            <a-step title="提交请款单">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state > 0">
                <div>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <!-- <a-step title="项目官员审核" /> -->
            <a-step title="项目主管审核" />
            <a-step title="财务审核" />
            <a-step title="负责人审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <div v-if="record.checkResult == -1">
          <a-alert class="v-mb-sm no-border" type="error">
            <div slot="message">
              <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此财务进展数据已被驳回</div>
              <div class="flex v-mt-xs">
                <span class="text-right text-grey">审核意见：</span>
                <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
              </div>
            </div>
          </a-alert>
        </div>
        <div class="panel-info-section relative-position">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary" />
            <span class="text-bold">财务进展基本信息</span>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="160">本次财务报销金额</th>
                <td width="32%"><b class="text-indigo">{{ $utils.thousands(record.billAmount) }}</b> 元</td>
                <th width="160">提交日期</th>
                <td>{{ record.submitTime ? record.submitTime.substring(0, 10) : '' }}</td>
              </tr>
              <tr>
                <th>本次财务进展说明</th>
                <td colspan="3">
                  <span>{{ record.billRemark }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="panel-info-section">
          <div class="flex items-center">
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">本次预审票据</span>
            </div>
          </div>
          <div class="flex">
            <div class="col">
              <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :pagination="false" :data-source="invoices" :scroll="{ x: '100%' }">
                <a-table-column title="序号" data-index="index" :width="55" align="left">
                  <template slot-scope="text, record, index">
                    {{ index + 1 }}
                  </template>
                </a-table-column>
                <a-table-column title="票据金额" data-index="invoiceAmount" :ellipsis="true" :width="120" align="left">
                  <template slot-scope="text, record">
                    <span>{{ $utils.thousands(record.invoiceAmount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="费用报销明细" data-index="amount" :width="320" align="left">
                  <template slot-scope="text, record">
                    <ul class="cell-list" v-if="record.budgets && record.budgets.length">
                      <li v-for="(item, idx) in record.budgets" :key="idx">
                        <a-badge color="#f24a78" />
                        {{ item.budgetPname }} — {{ item.budgetName }} / {{ $utils.thousands(item.amount) }} 元
                      </li>
                    </ul>
                  </template>
                </a-table-column>
                <a-table-column title="票据文件" data-index="quantity" :width="430" align="left">
                  <template slot-scope="text, record">
                    <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
                  </template>
                </a-table-column>
                <a-table-column title="票据说明" data-index="invoiceRemark" :width="300" align="left">
                  <template slot-scope="text, record">
                    <div class="lineh-13 text-ellipsis ellipsis-3-lines" v-html="$utils.convertToHtml(record.invoiceRemark)"></div>
                  </template>
                </a-table-column>
                <a-table-column title="子项目分摊费用" data-index="proj" :width="350" align="left">
                  <template slot-scope="text, record">
                    <ul class="cell-list" v-if="record.shares && record.shares.length">
                      <li v-for="(item, idx) in record.shares" :key="idx">
                        <div class="flex items-center">
                          <a-badge class="badge-dot-square" color="#3f51b5" />
                          <span class="v-mx-xs col ellipsis" :title="item.name">{{ item.name }}</span>
                          <span class="v-ml-auto">{{ $utils.thousands(item.amount) }} 元</span>
                        </div>
                      </li>
                    </ul>
                  </template>
                </a-table-column>
                <a-table-column title="" data-index="placeholder" :width="10" align="left" />
              </a-table>
            </div>
          </div>
        </div>
        <div class="panel-info-section">
          <div class="panel-info-section-title flex items-center">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">项目预算明细表</span>
            <a-space :size="8" class="v-ml-auto">
              <a-select size="small" v-model="budgetYear" allow-clear placeholder="费用年份" style="width: 94px" @change="onBudgetYearChange">
                <a-select-option :key="item" v-for="item in budgetYears">{{ item }}年</a-select-option>
              </a-select>
              <a-button icon="control" type="indigo" size="small" class="v-ml-auto" @click="rmbModal = true">查看费用报销比率</a-button>
            </a-space>
          </div>
          <div class="flex">
            <div class="col">
              <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :data-source="tableBudgets" :loading="budgetLoading" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
                <a-table-column title="序号" data-index="index" :width="60" align="left">
                  <template slot-scope="text, record">
                    {{ record.no }}
                  </template>
                </a-table-column>
                <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="280" align="left">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.name || '-' }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="费用类别" data-index="cate" :width="300" align="left">
                  <template slot-scope="text, record" v-if="!record.isRoot">
                    <div class="flex items-center">
                      <span class="col ellipsis" :title="record.cateFullName">{{ record.cateFullName }}</span>
                      <a-tag class="ml-auto v-pl-xs tag-tiny v-mr-none text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
                    </div>
                  </template>
                </a-table-column>
                <a-table-column title="费用年份" data-index="year" :width="90" align="center" :ellipsis="true">
                  <template slot-scope="text, record">
                    <template v-if="!record.isRoot">{{ record.year }}</template>
                  </template>
                </a-table-column>
                <a-table-column title="单价" data-index="price" :width="110" align="right" :ellipsis="true">
                  <template slot-scope="text, record">
                    <template v-if="!record.isRoot">{{ record.price }}</template>
                  </template>
                </a-table-column>
                <a-table-column title="数量" data-index="quantity" :width="90" align="right">
                  <template slot-scope="text, record">
                    <template v-if="!record.isRoot">{{ record.quantity }}</template>
                  </template>
                </a-table-column>
                <a-table-column title="预算金额" data-index="amount" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="请款金额" data-index="applied" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="实际已支出金额" data-index="expensed" :width="119" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="本次预审票据金额" :custom-cell="record => ({ class: 'td-bright' })" data-index="currentExpensed" :width="130" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum, 'text-primary': record.currentExpensed }">{{ record.extra ? '' : $utils.thousands(record.currentExpensed) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="累计支出金额" data-index="accuExpensed" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.accuExpensed) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="差额" data-index="subtract" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.amount - record.expensed) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="请款余额" :custom-cell="record => ({ class: 'td-bright' })" data-index="accuRemainApplied" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum, 'text-primary': record.remainApplied != record.accuRemainApplied }">{{ record.extra ? '' : $utils.thousands(record.accuRemainApplied) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="票据金额" data-index="invoiceAmount" :width="110" align="right">
                  <template slot-scope="text, record">
                    <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
                  </template>
                </a-table-column>
                <a-table-column title="票据文件" data-index="invoiceFiles" :width="330" align="left">
                  <template slot-scope="text, record">
                    <file-container v-if="record.files" :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01"></file-container>
                    <template slot-scope="text, record" v-else-if="record.name == '合计'">
                      <span>
                        <b class="text-primary">{{ record.fileTotal }}</b>
                        张发票
                      </span>
                    </template>
                  </template>
                </a-table-column>
              </a-table>
            </div>
          </div>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(record.state)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-if="record.state == 1">审核通过，提交主管审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 2">审核通过，提交财务审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 3">审核通过，提交负责人审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 4">审核通过</a-button>
            </template>
            <template v-if="hasPermission('project:main:talent:progress:delete') && (record.state == 0 || record.state == 9)">
              <a-button type="danger" :loading="saving" @click="handleRemove">
                <i class="fa fa-trash-o v-mr-sm"></i>
                删除
              </a-button>
            </template>
            <a-button icon="left" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回财务进展数据" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, 0)" v-if="[1, 2].includes(record.state)">确认驳回，退回至提交人</a-button>
          <!-- <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 1)" v-if="[2, 3, 4].includes(record.state)">确认驳回，退回至官员</a-button> -->
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 2)" v-if="[3, 4].includes(record.state)">确认驳回，退回至主管</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 3)" v-if="[4].includes(record.state)">确认驳回，退回至财务</a-button>
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
    <a-modal :mask-closable="false" centered title="费用报销比例" :footer="null" :visible="rmbModal" @cancel="rmbModal = false" :width="960" :body-style="{ padding: '12px' }">
      <a-table class="list-table" size="small" rowKey="uid" :pagination="false" :data-source="rmbRecords" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
        <a-table-column title="序号" data-index="index" :width="60" align="left">
          <template slot-scope="text, record, index" v-if="record.isRoot && !record.sum">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="费用类别" data-index="name" :width="300" align="left">
          <template slot-scope="text, record">
            <span class="col ellipsis" v-if="record.isRoot && !record.sum">{{ record.cateFullName }}</span>
            <span :class="{ 'text-bold': record.sum }" v-else>{{ record.name || '-' }}</span>
          </template>
        </a-table-column>
        <a-table-column title="预算金额" data-index="amount" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="费用报销比例" data-index="costRate" :width="120" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <a-tag class="tag-tiny text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="费用报销上限" data-index="costAmount" :width="110" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <span v-if="record.cateRoot == 2 && record.rmbRate != void 0">{{ $utils.thousands((record.manageAmount * record.rmbRate) / 100) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="请款金额" data-index="applied" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="实际支出金额" data-index="expensed" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getProgressBill, reviewProgressBill, delProgressBill } from '@/api/project/common'
import { convertBudgetsRecords, mergeTableBudgetsAndInvoices } from '@/utils/data'
export default {
  name: 'FundedProjectProgressBill',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      billId: +this.$route.query.bid,
      loading: false,
      invoices: [],
      record: {},
      expandedBudgetKeys: [],
      budgetYears: [],
      budgetYear: undefined,
      tableBudgetsAll: [],
      tableBudgets: [],
      budgetLoading: false,
      saving: false,
      currentStep: 0,
      rejectModal: false,
      rejectReason: '',
      rmbRecords: [],
      rmbModal: false,
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, bid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (bid) {
        this.billId = +bid
        this.loadBill()
      }
    },
    loadBill() {
      this.loading = true
      getProgressBill(this.billId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
          let { state, invoices, budgets = {} } = data.result
          this.invoices = invoices.map(item => ({
            uid: item.invoiceId,
            invoiceId: item.invoiceId,
            invoiceRemark: item.invoiceRemark,
            invoiceAmount: item.invoiceAmount,
            budgets: item.invoiceBudgets.map(item => ({
              amount: item.amount,
              budgetPid: item.budgetPid,
              budgetId: item.budgetId,
              budgetName: item.budget && item.budget.name,
              budgetPname: item.budget && item.budget.pname,
              budgetAmount: item.budget && item.budget.amount,
              budgetExpensed: item.budget && item.budget.expensed,
            })),
            shares: item.invoiceShares.map(item => ({
              amount: item.amount,
              projectId: item.projectId,
              name: item.project && item.project.name,
            })),
            files: item.files.map(file => ({
              ...file,
              uid: file.fileId,
              name: file.fileName,
              status: 'done',
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${this.projectId}&fileSign=P01`,
            })),
          }))
          this.dealBudgetRecords(budgets)
          this.currentStep = state == 9 ? 4 : state - 1
        }
        this.loading = false
      })
    },
    dealBudgetRecords(data) {
      let { records, raisedAmount, ownManageRate } = data
      let { years, tableRecords, rmbRecords } = convertBudgetsRecords(records, { showOwnManage: true, raisedAmount, ownManageRate })
      this.budgetYears = years
      this.tableBudgetsAll = tableRecords
      this.tableBudgets = tableRecords
      this.rmbRecords = rmbRecords
      this.expandedBudgetKeys = tableRecords.filter(d => d.children && d.children.length).map(d => d.uid)
      mergeTableBudgetsAndInvoices(this.invoices, this.tableBudgetsAll)
    },
    onBudgetYearChange(value) {
      this.tableBudgets = value ? this.tableBudgetsAll.filter(item => item.sum || (item.children && item.children.some(d => d.year == value))) : this.tableBudgetsAll
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { billId, projectId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        id: billId,
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewProgressBill(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.$router.go(-1)
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.warn('操作失败')
        })
    },
    handleRemove() {
      let { state } = this.record
      this.$confirm({
        title: '确认删除此财务进展数据？',
        okText: '确认删除',
        content: state == 9 ? h => <div class="text-red font-13">已审核通过的财务进展数据删除后，对应预算的已支出金额将会回滚。</div> : null,
        centered: true,
        onOk: () => {
          this.saving = true
          let { billId, projectId } = this
          return new Promise((resolve, reject) => {
            delProgressBill(billId, projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.go(-1)
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
              this.saving = false
            })
          })
        },
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
